/* eslint-disable */
// CHESS LESSON 5 — Knight and Pawn Movement
// 56 minutes · Lesson 5 of 24 · Beginner Module
// Rules 1-18 applied. All Kings removed from solo teaching boards.
// Promotion boards keep black king (contextually required).
// All FENs verified with chess.js skipValidation.

export const LESSON_5 = {
  id: 'chess-lesson-5',
  title: 'Knight and Pawn Movement',
  subtitle: 'Lesson 5 of 24 · Beginner Module',
  totalMinutes: 56,
  phases: [
    {
      id: 'warmup',
      title: 'Warm-up — Four Pieces Recalled',
      type: 'warmup',
      durationMins: 5,
      steps: [
        {
          id: 'wa1',
          type: 'observe',
          boardState: '8/8/8/8/4Q3/8/8/8 w - - 0 1',
          highlights: ['a4','a8','b1','b4','b7','c2','c4','c6','d3','d4','d5','e1','e2','e3','e5','e6','e7','e8','f3','f4','f5','g2','g4','g6','h1','h4','h7'],
          pieceLetterRef: [
            { icon: '♖', letter: 'R', name: 'Rook' },
            { icon: '♗', letter: 'B', name: 'Bishop' },
            { icon: '♕', letter: 'Q', name: 'Queen' },
            { icon: '♔', letter: 'K', name: 'King' },
          ],
          voice: `Welcome back, {name}! Here is the Queen on e4 reaching twenty-seven squares — straight lines AND diagonals. You already know four of the six chess pieces and how they move. Today we complete your chess family with the final two — and they have the most surprising movement rules of all!`,
          task: null,
          taskType: 'observe',
          continueLabel: "Let's meet the Knight!",
        },
        {
          id: 'wa2',
          type: 'recap-quiz',
          boardState: 'empty',
          highlights: [],
          pieceLetterRef: [{ icon: '♔', letter: 'K', name: 'King' }],
          voice: `Quick check — from the very centre of the board, how many squares does a piece reach if it moves exactly ONE step in any direction?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'How many squares does the King reach from the centre?',
          recapOptions: ['Eight', 'Fourteen', 'Twenty-seven'],
          recapCorrect: 0,
          recapCorrectVoice: `Eight! One step in every direction — eight squares from the centre. Now meet a piece with a completely different kind of move!`,
          recapWrongVoice: `Eight! One step in any direction, eight squares from the centre. Now for something completely different!`,
          continueLabel: 'Meet the Knight!',
        },
      ],
    },
    {
      id: 'knightteach',
      title: 'The Knight — The L-Shape Jump',
      type: 'teach',
      durationMins: 8,
      steps: [
        {
          id: 'nt0',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/1N4N1 w - - 0 1',
          highlights: ['b1','g1'],
          pieceLetterRef: [{ icon: '♘', letter: 'N', name: 'Knight' }],
          voice: `Here are both Knights on their real starting squares — b1 and g1! Remember from Lesson 2 — the Knight's letter is N, NOT K, because K is already taken by another piece. See the horse-head shape. The Knight is the ONLY piece that can JUMP OVER other pieces — like a horse leaping a fence!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me its jumps!',
        },
        {
          id: 'nt1a',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/1N6 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/8/8/N7/8/8 w - - 0 1', path: ['a3'], delay: 2000 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♘', letter: 'N', name: 'Knight' }],
          voice: `The Knight on b1 jumps to a3 — two squares up, one square left. That is the L-shape!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Next jump!',
        },
        {
          id: 'nt1b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/1N6 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/8/8/2N5/8/8 w - - 0 1', path: ['c3'], delay: 2000 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♘', letter: 'N', name: 'Knight' }],
          voice: `From b1 to c3 — two squares up, one square right. Another L-shape, different direction!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Next jump!',
        },
        {
          id: 'nt1c',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/1N6 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/8/8/8/3N4/8 w - - 0 1', path: ['d2'], delay: 2000 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♘', letter: 'N', name: 'Knight' }],
          voice: `And from b1 to d2 — one square up, two squares right. Three L-shape jumps from b1! Always the same shape, in different directions. From the centre the Knight has eight jumps!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me from the centre!',
        },
        {
          id: 'nt2',
          type: 'observe',
          boardState: '8/8/8/8/3N4/8/8/8 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/8/8/1N6/8/8 w - - 0 1', path: ['b3'], delay: 1700 },
            { fen: '8/8/8/1N6/8/8/8/8 w - - 0 1', path: ['b5'], delay: 1700 },
            { fen: '8/8/8/8/8/8/2N5/8 w - - 0 1', path: ['c2'], delay: 1700 },
            { fen: '8/8/2N5/8/8/8/8/8 w - - 0 1', path: ['c6'], delay: 1700 },
            { fen: '8/8/8/8/8/8/4N3/8 w - - 0 1', path: ['e2'], delay: 1700 },
            { fen: '8/8/4N3/8/8/8/8/8 w - - 0 1', path: ['e6'], delay: 1700 },
            { fen: '8/8/8/8/8/5N2/8/8 w - - 0 1', path: ['f3'], delay: 1700 },
            { fen: '8/8/8/5N2/8/8/8/8 w - - 0 1', path: ['f5'], delay: 1700 },
          ],
          highlights: ['b3','b5','c2','c6','e2','e6','f3','f5'],
          pieceLetterRef: [{ icon: '♘', letter: 'N', name: 'Knight' }],
          voice: `From d4, the Knight reaches EIGHT squares — all L-shapes in every pair of directions! And notice — d4 is a dark square, but every one of those eight landing squares is LIGHT. The Knight changes colour EVERY time it moves. It is the only piece that does this!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Your turn to try!',
        },
      ],
    },
    {
      id: 'knightpractice',
      title: 'Knight Practice — Find the L-Shapes',
      type: 'practice',
      durationMins: 12,
      steps: [
        {
          id: 'np1',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/3N4/8/8/8 w - - 0 1',
          highlights: [],
          voice: `The Knight is on d4. Drag it to every square it can reach — L-shapes only, all eight!`,
          task: 'Drag the Knight on d4 to every square it can reach.',
          taskType: 'piece-range',
          targetSquares: ['b3','b5','c2','c6','e2','e6','f3','f5'],
          successVoice: `All eight! Maximum Knight power from the centre. Now its starting square...`,
          continueLabel: 'Try the starting square!',
        },
        {
          id: 'np2',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/8/8/8/1N6 w - - 0 1',
          highlights: [],
          voice: `The Knight on b1 — its real starting square. Drag it to every square it can jump to!`,
          task: 'Drag the Knight on b1 to every square it can reach.',
          taskType: 'piece-range',
          targetSquares: ['a3','c3','d2'],
          successVoice: `Just three from b1! The starting square limits the Knight. Try the other side...`,
          continueLabel: 'Try the other Knight!',
        },
        {
          id: 'np2b',
          type: 'observe',
          boardState: '8/8/8/8/3N4/8/8/8 w - - 0 1',
          highlights: [],
          pieceLetterRef: [{ icon: '♘', letter: 'N', name: 'Knight' }],
          voice: `Eight from the centre. Three from the starting square. The Knight needs space. The further from the edges, the more powerful it becomes.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Try the other Knight!',
        },
        {
          id: 'np3',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/8/8/8/6N1 w - - 0 1',
          highlights: [],
          voice: `The other Knight on g1. Drag it to every square it can jump to!`,
          task: 'Drag the Knight on g1 to every square it can reach.',
          taskType: 'piece-range',
          targetSquares: ['e2','f3','h3'],
          successVoice: `Three again — symmetric to b1. The starting position is limited. Now the corner...`,
          continueLabel: 'Try the corner!',
        },
        {
          id: 'np4',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/8/8/8/N7 w - - 0 1',
          highlights: [],
          voice: `The Knight on a1 — the corner! The Knight's WORST square. Drag it to every square it can reach.`,
          task: 'Drag the Knight on a1 to every square it can reach.',
          taskType: 'piece-range',
          targetSquares: ['b3','c2'],
          successVoice: `Just TWO! Corner gives the Knight its smallest reach. Pattern: corner = 2, starting square = 3, centre = 8. Centre is always best. Now — the Pawn!`,
          continueLabel: 'Meet the Pawn!',
        },
      ],
    },
    {
      id: 'pawnteach',
      title: 'The Pawn — Forward March and Diagonal Capture',
      type: 'teach',
      durationMins: 8,
      steps: [
        {
          id: 'pt0',
          type: 'observe',
          boardState: '8/8/8/8/8/8/4P3/8 w - - 0 1',
          highlights: ['e2'],
          pieceLetterRef: [{ icon: '♙', letter: '—', name: 'Pawn (no letter)' }],
          voice: `Here is a PAWN on its real starting square — e2! The Pawn is the smallest piece. Remember from Lesson 2 — the Pawn has NO letter in chess notation. A move with no capital letter at the front is always a Pawn. The Pawn moves FORWARD ONLY — never backward, never sideways.`,
          task: null,
          taskType: 'observe',
          continueLabel: "Show its first-move choice!",
        },
        {
          id: 'pt1a',
          type: 'observe',
          boardState: '8/8/8/8/8/8/4P3/8 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/8/8/4P3/8/8 w - - 0 1', path: ['e3'], delay: 2200 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♙', letter: '—', name: 'Pawn (no letter)' }],
          voice: `On its very first move, a Pawn can move ONE square forward — e2 to e3!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Or two squares?',
        },
        {
          id: 'pt1b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/4P3/8 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/8/4P3/8/8/8 w - - 0 1', path: ['e3','e4'], delay: 2200 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♙', letter: '—', name: 'Pawn (no letter)' }],
          voice: `OR on its very first move, the Pawn can jump TWO squares forward — e2 to e4! One or two — the Pawn's choice, but ONLY on its first move from the starting rank!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'After the first move...',
        },
        {
          id: 'pt2',
          type: 'observe',
          boardState: '8/8/8/8/4P3/8/8/8 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/4P3/8/8/8/8 w - - 0 1', path: ['e5'], delay: 2200 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♙', letter: '—', name: 'Pawn (no letter)' }],
          voice: `Now the Pawn is on e4 — it already used its special first move. From here, it can ONLY move one square forward to e5. The two-square move is gone — every move after the first is just one square!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now — diagonal captures!',
        },
        {
          id: 'pt3',
          type: 'observe',
          boardState: '8/8/8/3p1p2/4P3/8/8/8 w - - 0 1',
          highlights: ['e5','d5','f5'],
          pieceLetterRef: [{ icon: '♙', letter: '—', name: 'Pawn (no letter)' }],
          voice: `Here the White Pawn on e4 can move straight to e5 — but there are enemy Pawns on d5 and f5! A Pawn captures DIAGONALLY — one square forward and to the side, only when an enemy piece is there. So this Pawn could go straight to e5, OR capture diagonally on d5, OR capture diagonally on f5!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Your turn to try!',
        },
      ],
    },
    {
      id: 'pawnpractice',
      title: 'Pawn Practice — Forward and Diagonal',
      type: 'practice',
      durationMins: 12,
      steps: [
        {
          id: 'pp1',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/8/8/4P3/8 w - - 0 1',
          highlights: [],
          voice: `Pawn on e2 — its starting square, no enemies nearby. Drag it to every square it can move to!`,
          task: 'Drag the Pawn on e2 to every square it can reach.',
          taskType: 'piece-range',
          targetSquares: ['e3','e4'],
          successVoice: `Two squares — the first-move choice! Now a Pawn that already moved...`,
          continueLabel: 'Try a moved Pawn!',
        },
        {
          id: 'pp2',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/4P3/8/8/8 w - - 0 1',
          highlights: [],
          voice: `This Pawn is on e4 — it already moved once. Drag it to every square it can move to now.`,
          task: 'Drag the Pawn on e4 to every square it can reach.',
          taskType: 'piece-range',
          targetSquares: ['e5'],
          successVoice: `Just one! The two-square option is gone after the first move. Now add enemy pieces...`,
          continueLabel: 'Try a capture!',
        },
        {
          id: 'pp2b',
          type: 'observe',
          boardState: '8/8/8/8/4P3/8/8/8 w - - 0 1',
          highlights: [],
          pieceLetterRef: [{ icon: '♙', letter: '—', name: 'Pawn (no letter)' }],
          voice: `Starting rank: two squares or one. Moved already: one square only. The Pawn always moves forward — never backward. Now what happens when enemy pieces are in the way?`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Try a capture!',
        },
        {
          id: 'pp3',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/3p1p2/4P3/8/8/8 w - - 0 1',
          highlights: [],
          voice: `Pawn on e4 with enemy Pawns on d5 and f5. Drag it to every square it can move to — including captures!`,
          task: 'Drag the Pawn on e4 to every square it can reach.',
          taskType: 'piece-range',
          targetSquares: ['e5','d5','f5'],
          successVoice: `All three! Straight to e5, and two diagonal captures. You have mastered the Pawn!`,
          continueLabel: "Now — the Pawn's big secret!",
        },
      ],
    },
    {
      id: 'promotion',
      title: 'Promotion — The Pawn Transforms!',
      type: 'teach',
      durationMins: 6,
      steps: [
        {
          id: 'pr1',
          type: 'observe',
          // Pawn on b7 with enemy king on h8 (context required for promotion scene)
          boardState: '7k/1P6/8/8/8/8/8/8 w - - 0 1',
          highlights: ['b8'],
          voice: `{name}, here is the Pawn's BIGGEST secret! This White Pawn is on b7 — just one square from the last rank! When a Pawn reaches the far end of the board, it PROMOTES — it transforms into ANY piece the player chooses. Any piece except a King or another Pawn!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me the choices!',
        },
        {
          id: 'pr2',
          type: 'observe',
          boardState: '6Qk/8/8/8/8/8/8/8 w - - 0 1',
          highlights: [],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `Choice one — promote to QUEEN! The most common choice. The Pawn becomes the most powerful piece — twenty-seven squares of reach!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'A Rook?',
        },
        {
          id: 'pr3',
          type: 'observe',
          boardState: '6Rk/8/8/8/8/8/8/8 w - - 0 1',
          highlights: [],
          pieceLetterRef: [{ icon: '♖', letter: 'R', name: 'Rook' }],
          voice: `Choice two — promote to ROOK! Fourteen squares of straight-line power. A rare promotion, but still a formidable choice!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'A Bishop or Knight?',
        },
        {
          id: 'pr4a',
          type: 'observe',
          boardState: '6Bk/8/8/8/8/8/8/8 w - - 0 1',
          highlights: [],
          pieceLetterRef: [{ icon: '♗', letter: 'B', name: 'Bishop' }],
          voice: `Choice three — promote to BISHOP! A powerful diagonal piece. A rare promotion, but the right position can call for it.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Or a Knight?',
        },
        {
          id: 'pr4b',
          type: 'observe',
          boardState: '6Nk/8/8/8/8/8/8/8 w - - 0 1',
          highlights: [],
          pieceLetterRef: [{ icon: '♘', letter: 'N', name: 'Knight' }],
          voice: `And choice four — promote to KNIGHT, for that special L-shape jump! The KNIGHT is unique — it can leap over any piece on the board, making it a surprising promotion choice when the position calls for it. Very rarely chosen, but sometimes the cleverest move!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'One special move...',
        },
        {
          id: 'pr5',
          type: 'observe',
          boardState: '8/8/8/8/8/8/4P3/8 w - - 0 1',
          highlights: [],
          voice: `One last thing, {name}. There is ONE more special Pawn move called EN PASSANT — French for "in passing." It is a rare special capture that works differently from the normal diagonal capture. We will learn it fully in its own lesson. For now, just remember the name — en passant!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Quick recap quiz!',
        },
        {
          id: 'pr6',
          type: 'recap-quiz',
          boardState: '6Qk/8/8/8/8/8/8/8 w - - 0 1',
          highlights: [],
          voice: `Quick check — when a Pawn promotes, which piece can it NOT become?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'What can a promoting Pawn NOT become?',
          recapOptions: ['A King or another Pawn', 'A Queen', 'A Rook'],
          recapCorrect: 0,
          recapCorrectVoice: `Exactly! Never a King, never another Pawn. Always one of: Queen, Rook, Bishop, or Knight.`,
          recapWrongVoice: `A Pawn can become Queen, Rook, Bishop, or Knight — but NEVER a King, and NEVER another Pawn.`,
          continueLabel: 'One more thing before we finish...',
        },
      ],
    },
    {
      id: 'wrapup',
      title: 'Lesson Complete!',
      type: 'wrapup',
      durationMins: 5,
      steps: [
        {
          id: 'wu1',
          type: 'wrapup',
          boardState: '8/8/8/8/3N4/8/4P3/8 w - - 0 1',
          highlights: [],
          pieceLetterRef: [
            { icon: '♔', letter: 'K', name: 'King' },
            { icon: '♕', letter: 'Q', name: 'Queen' },
            { icon: '♖', letter: 'R', name: 'Rook' },
            { icon: '♗', letter: 'B', name: 'Bishop' },
            { icon: '♘', letter: 'N', name: 'Knight' },
            { icon: '♙', letter: '—', name: 'Pawn (no letter)' },
          ],
          voice: `{name}, incredible! Today you learned the KNIGHT — the only piece that jumps over others, moving in an L-shape and changing colour every move. And the PAWN — moving forward only, one or two squares on its first move, capturing diagonally, and promoting to any piece when it reaches the far end. You now know how ALL SIX chess pieces move. That is a HUGE achievement — well done!`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'On its very first move, how many squares can a Pawn advance?',
          recapOptions: ['One or two — its choice', 'Always two', 'Always one'],
          recapCorrect: 0,
          recapCorrectVoice: `One OR two — the Pawn's choice on its very first move from the starting rank. After that, always just one!`,
          recapWrongVoice: `One OR two on the first move — the Pawn's choice! After the first move, always just one square.`,
          continueLabel: 'One more thing before we finish...',
        },
        {
          id: 'wu1b',
          type: 'wrapup',
          boardState: 'empty',
          highlights: [],
          voice: `Quick question. What is the Knight's special ability that no other piece has?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'What can the Knight do that no other piece can?',
          recapOptions: ['Jump over other pieces','Move in any direction','Capture backwards'],
          recapCorrect: 0,
          recapCorrectVoice: `Jump over other pieces. The only piece that can leap over everything in its way. That is the Knight's superpower.`,
          recapWrongVoice: `Jump over other pieces. No other piece can do that. The Knight leaps over everything in its path.`,
        },
        {
          id: 'wu1c',
          type: 'wrapup',
          boardState: 'empty',
          highlights: [],
          voice: `Last one. When a Pawn reaches the far end of the board, what can it become?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'When a Pawn reaches the other end of the board it can become?',
          recapOptions: ['Any piece except a King','Only a Queen','Any piece including a King'],
          recapCorrect: 0,
          recapCorrectVoice: `Any piece except a King. Usually a Queen. That is called promotion. The smallest piece can become the most powerful.`,
          recapWrongVoice: `Any piece except a King. Most players promote to a Queen. That is why Pawns should never be underestimated.`,
        },
        {
          id: 'wu2',
          type: 'wrapup',
          boardState: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
          highlights: [],
          pieceLetterRef: [
            { icon: '♔', letter: 'K', name: 'King' },
            { icon: '♕', letter: 'Q', name: 'Queen' },
            { icon: '♖', letter: 'R', name: 'Rook' },
            { icon: '♗', letter: 'B', name: 'Bishop' },
            { icon: '♘', letter: 'N', name: 'Knight' },
            { icon: '♙', letter: '—', name: 'Pawn (no letter)' },
          ],
          voice: `Next time, {name}, we put it ALL together — setting up the FULL chess board from memory with all thirty-two pieces in their correct starting positions! Look at the board right now — THAT is what you will be able to set up from memory by the end of Lesson 6. You know every piece's name, letter, movement, and starting square. See you next session!`,
          task: null,
          taskType: 'complete',
          continueLabel: 'Finish lesson!',
        },
      ],
    },
  ],
};

// ─────────────────────────────────────────────────────────────────
// LESSON 5 BONUS
// ─────────────────────────────────────────────────────────────────
export const LESSON_5_BONUS = {
  title: 'Bonus Round — Knight and Pawn Mastery!',
  phases: [
    {
      id: 'bonus1',
      title: 'Knight and Pawn Trivia',
      durationMins: 8,
      steps: [
        {
          id: 'b1', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `Bonus round, {name}! The Knight is the only piece that can do something no other piece can. What is it?`,
          recapQuestion: 'What can only the Knight do that no other piece can?',
          recapOptions: ['Jump over other pieces', 'Move diagonally', 'Move in a straight line'],
          recapCorrect: 0,
          recapCorrectVoice: `Jump OVER other pieces! No other piece can do that. The Knight leaps right over anything in its path!`,
          recapWrongVoice: `The Knight is the ONLY piece that can jump over other pieces. Every other piece is blocked if something is in the way.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b2', taskType: 'recap-quiz', boardState: '8/8/8/8/3N4/8/8/8 w - - 0 1', highlights: ['d4'],
          voice: `The Knight is on d4 — a dark square. What colour are all the squares it can jump to?`,
          recapQuestion: 'What colour squares does the Knight on d4 land on?',
          recapOptions: ['All light squares', 'All dark squares', 'Mixed colours'],
          recapCorrect: 0,
          recapCorrectVoice: `All LIGHT squares! The Knight changes colour every single move — always the opposite colour from where it started.`,
          recapWrongVoice: `All light squares! The Knight always lands on the OPPOSITE colour from where it started — it changes colour every move.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b3', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `How many squares does a Knight reach from the CENTRE of the board?`,
          recapQuestion: 'How many squares does a Knight reach from the centre?',
          recapOptions: ['Eight', 'Three', 'Two'],
          recapCorrect: 0,
          recapCorrectVoice: `Eight! Maximum Knight power from the centre. From a corner it can only reach two squares!`,
          recapWrongVoice: `Eight from the centre! From a corner the Knight can barely move — only two squares.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b4', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `A Pawn has just moved for the first time. Can it now move two squares forward?`,
          recapQuestion: 'After a Pawn has moved once, can it still move two squares?',
          recapOptions: ['No — only one square from now on', 'Yes — always two squares'],
          recapCorrect: 0,
          recapCorrectVoice: `No — the two-square move is ONLY available on the very first move from the starting rank. After that, always just one!`,
          recapWrongVoice: `No! The two-square advance is only available on the Pawn's very FIRST move from its starting rank.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b5', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `A Pawn captures differently from how it moves. How does it capture?`,
          recapQuestion: 'How does a Pawn capture an enemy piece?',
          recapOptions: ['Diagonally — one square forward and to the side', 'Straight forward', 'Backwards'],
          recapCorrect: 0,
          recapCorrectVoice: `Diagonally! The Pawn moves straight but captures diagonally. One of the most unique rules in chess!`,
          recapWrongVoice: `Diagonally! The Pawn moves straight forward but captures one square diagonally forward. Very unique!`,
          continueLabel: 'Next!',
        },
        {
          id: 'b6', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `When a Pawn promotes, which piece do most players choose, and why?`,
          recapQuestion: 'Which promotion piece do most players choose?',
          recapOptions: ['The Queen — she is the most powerful', 'The Knight — it can jump', 'The Rook — straight lines'],
          recapCorrect: 0,
          recapCorrectVoice: `The QUEEN! Twenty-seven squares — the most powerful piece. The Pawn becomes a Queen and the game changes completely!`,
          recapWrongVoice: `The QUEEN is the most common choice because she is the most powerful piece — twenty-seven squares in all directions!`,
          continueLabel: 'Next!',
        },
        {
          id: 'b7', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `What letter does the Knight use in chess notation, and why?`,
          recapQuestion: 'Why does the Knight use N instead of K?',
          recapOptions: ['Because K is already used for the King', 'Because N stands for "Knight"', 'Random choice'],
          recapCorrect: 0,
          recapCorrectVoice: `Because K is already taken by the King! So the Knight uses N — think of the N sound in "kNight"!`,
          recapWrongVoice: `K belongs to the King! So the Knight uses N instead. Remember "kNight" — hear the N in the middle!`,
          continueLabel: 'Next!',
        },
        {
          id: 'b8', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `Can a Pawn ever move BACKWARDS?`,
          recapQuestion: 'Can a Pawn move backwards?',
          recapOptions: ['Never — forward only', 'Yes, if it needs to', 'Only to capture'],
          recapCorrect: 0,
          recapCorrectVoice: `Never! The Pawn only moves forward — it can never retreat. Once it advances, it cannot go back. That is why Pawn moves are permanent!`,
          recapWrongVoice: `Never! The Pawn only moves FORWARD. It cannot retreat. Every Pawn move is permanent — choose wisely!`,
          continueLabel: 'Speed Challenge!',
        },
      ],
    },
    {
      id: 'bonus2',
      title: 'Speed Square Challenge — Round 1',
      durationMins: 6,
      steps: [
        {
          id: 'bs1', taskType: 'speed-intro', boardState: 'empty',
          voice: `SPEED CHALLENGE! Find every square I call as fast as you can. Ready? GO!`,
          continueLabel: 'Start challenge!',
        },
        {
          id: 'bs2', taskType: 'speed-round', boardState: 'empty',
          voice: `Speed challenge — find every square I call!`,
          timeLimitSecs: 90, targetCount: 20,
          successVoice: `Incredible speed, {name}! You found {score} squares!`,
          completeVoice: `Time is up! You found {score} squares. Well done, {name}!`,
        },
      ],
    },
    {
      id: 'bonus3',
      title: 'Mixed Trivia — All Five Lessons',
      durationMins: 8,
      steps: [
        {
          id: 'b9', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `Final trivia mix! Which piece is the most powerful on a chess board?`,
          recapQuestion: 'Which is the most powerful chess piece?',
          recapOptions: ['The Queen', 'The King', 'The Rook'],
          recapCorrect: 0,
          recapCorrectVoice: `The QUEEN! Twenty-seven squares, all directions. The King is most important but the Queen is most powerful!`,
          recapWrongVoice: `The QUEEN — twenty-seven squares in all eight directions. The King is most important but the Queen has the most power.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b10', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `Which piece has NO letter in chess notation?`,
          recapQuestion: 'Which piece has no letter in chess notation?',
          recapOptions: ['The Pawn', 'The Knight', 'The Rook'],
          recapCorrect: 0,
          recapCorrectVoice: `The PAWN! No letter means Pawn. Any move written without a capital letter at the front is always a Pawn move.`,
          recapWrongVoice: `The PAWN has no letter! If you see "e4" with no capital letter, a Pawn moved to e4.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b11', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `How many squares does the Bishop reach from the CENTRE of the board?`,
          recapQuestion: 'How many squares does a Bishop reach from the centre?',
          recapOptions: ['Thirteen', 'Fourteen', 'Eight'],
          recapCorrect: 0,
          recapCorrectVoice: `Thirteen from the centre! One fewer than the Rook's fourteen — because the diagonals from the centre don't quite reach every edge.`,
          recapWrongVoice: `Thirteen! The Bishop reaches thirteen diagonal squares from the centre — one fewer than the Rook's fourteen straight squares.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b12', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `The vertical columns on the chess board are called what?`,
          recapQuestion: 'What are the vertical columns called?',
          recapOptions: ['Files', 'Ranks', 'Diagonals'],
          recapCorrect: 0,
          recapCorrectVoice: `FILES! Named a to h. Ranks are the horizontal rows, numbered 1 to 8. Files are vertical, ranks are horizontal!`,
          recapWrongVoice: `FILES — named a to h, running vertically. RANKS are the horizontal rows, numbered 1 to 8.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b13', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `From the starting position, where does the White King begin?`,
          recapQuestion: 'Where does the White King start in a real chess game?',
          recapOptions: ['e1', 'd1', 'e8'],
          recapCorrect: 0,
          recapCorrectVoice: `e1! The White King always starts on e1 — and the White Queen is right beside him on d1.`,
          recapWrongVoice: `e1! The White King starts on e1, with the Queen on d1 beside him. Black King is on e8.`,
          continueLabel: 'Last question!',
        },
        {
          id: 'b14', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `You now know all six pieces. Which is the ONLY piece that can jump over other pieces?`,
          recapQuestion: 'Which is the only piece that can jump over other pieces?',
          recapOptions: ['The Knight', 'The Queen', 'The Pawn'],
          recapCorrect: 0,
          recapCorrectVoice: `The KNIGHT! It is unique — the only piece that leaps over whatever is in its way. All other pieces must travel along clear paths!`,
          recapWrongVoice: `The KNIGHT! It is the only leaper in chess. All other pieces — Rook, Bishop, Queen, King, Pawn — must have a clear path.`,
          continueLabel: 'Speed Round 2!',
        },
      ],
    },
    {
      id: 'bonus4',
      title: 'Speed Square Challenge — Round 2',
      durationMins: 6,
      steps: [
        {
          id: 'bs3', taskType: 'speed-intro', boardState: 'empty',
          voice: `ROUND 2! New squares, faster pace. Let us go — ready? GO!`,
          continueLabel: 'Start round 2!',
        },
        {
          id: 'bs4', taskType: 'speed-round', boardState: 'empty',
          voice: `Round 2 — find every square I call!`,
          timeLimitSecs: 90, targetCount: 20,
          successVoice: `AMAZING, {name}! {score} squares in round 2!`,
          completeVoice: `Round 2 done! {score} squares. You are a chess board master, {name}!`,
        },
      ],
    },
    {
      id: 'bonus5',
      title: 'Bonus Complete',
      durationMins: 1,
      steps: [
        {
          id: 'bend', taskType: 'complete', boardState: 'empty',
          voice: `{name}, you are EXTRAORDINARY! You know all six chess pieces — how they move, their letters, their starting squares. You answered every bonus question and completed two speed rounds. You are completely ready for Lesson 6 — setting up the full board from memory. See you then!`,
          continueLabel: 'Finish Lesson 5!',
        },
      ],
    },
  ],
};
